export default "__VITE_PUBLIC_ASSET__46adb3ca__"